import React from "react";
import Responsive from "react-responsive";
import styled from "styled-components";

export const Desktop = props => <Responsive {...props} minWidth={1024} />;
export const Mobile = props => <Responsive {...props} maxWidth={1023} />;
export const NotPhone = props => <Responsive {...props} minWidth={813} />;
export const Tablet = props => (
  <Responsive {...props} minWidth={768} maxWidth={1023} />
);
export const Phone = props => <Responsive {...props} maxWidth={812} />;

export const helloAvaTheme = {
  botBubbleColor: "rgba(255, 173, 148, 0.1)",
  botFontColor: "black",
  userBubbleColor: "rgba(151, 151, 151, 0.1)",
  userFontColor: "black"
};

export const quizStyle = {
  height: "92%",
  // display: 'flex',
  // overflow: 'hidden',
  padding: "calc(10vh + 0.75em) 0 6%",
  width: "calc(100% - 40px)",
  // overflow: 'hidden'
  // border: '20px solid #000'
  overflow: "hidden",
  borderLeft: "20px solid #000",
  borderRight: "20px solid #000"
};

export const quizStyleMobile = {
  height: "93%",
  overflow: "hidden",
  padding: "7vh 0 3%",
  width: "103%",
  overflowY: "hidden"
  // border: '20px solid #000'
};

export const chatContainerStyle = {
  // paddingTop: '4%',
  height: "100%"
};

export const chatbotStyle = {
  width: "100%",
  maxWidth: "1360px",
  height: "100%",
  //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
  background: "#fff",
  overflow: "hidden"
};

export const chatContentStyle = {
  height: "auto",
  // maxHeight: "800px",
  margin: 0,
  width: "100%"
  // padding: "0 25px 0 0"
};

export const chatbotContentStyleMobile = {
  height: "100vh",
  margin: 0,
  padding: "1.5em 25px 4% 0",
  width: "100%",
  overflowY: "scroll"
};

export const chatbotAvatarStyle = {
  width: "61px",
  height: "61px"
};

export const chatbotAvatarStyleMobile = {
  width: "40px",
  height: "40px"
};

export const chatbotBubbleStyle = {
  fontFamily: "Open Sans",
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: 1.56,
  letterSpacing: "0px",
  textAlign: "left",
  padding: "17px 25px 17px 25px",
  margin: "0 0 10px 0",
  borderRadius: "27px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

export const chatbotBubbleStyleMobile = {
  fontFamily: "Open Sans",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: 1.56,
  letterSpacing: "0px",
  textAlign: "left",
  padding: "10px 20px 10px 20px",
  margin: "0 0 10px 0",
  overflowY: "hidden",
  borderRadius: "27px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

// This is for custom component - name, skin concerns, products and allergies
export const answerBubbleStyle = {
  fontFamily: "Open Sans",
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: 1.56,
  letterSpacing: "0px",
  textAlign: "left",
  padding: "17px 25px 17px 25px",
  margin: "0 0 10px 0",
  borderRadius: "27px",
  backgroundColor: "rgba(151, 151, 151, 0.1)",
  color: "black",
  maxWidth: "50%"
};

export const answerBubbleStyleMobile = {
  fontFamily: "Open Sans",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: 1.56,
  letterSpacing: "0px",
  textAlign: "left",
  padding: "10px 20px",
  margin: "0 0 10px 0",
  borderRadius: "27px",
  backgroundColor: "rgba(151, 151, 151, 0.1)",
  color: "black",
  maxWidth: "50%"
};

export const chatbotFooterStyle = {
  display: "none"
};

export const ChatContainerWrapper = styled.div`
  width: calc(100% - 40px);
  height: 100%;
  overflow: hidden;
  overscroll-behavior: none;
  border-left: 20px solid #000;
  border-right: 20px solid #000;

  @media screen and (max-width: 813px) {
    border: none;
  }
`;

export const ChatContainer = styled.div`
  height: 92% !important;
  width: 100%;
  overscroll-behavior: none;

  .rsc {
    /* max-height: 900px; */
    max-height: 950px;
    max-width: 1200px;
    overflow: hidden;
    height: 100%;
    margin: 0 auto;
  }

  .rsc-container {
    padding-top: 55px;
    height: 100%;
    width: 102%;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
  }

  @media screen and (min-width: 813px) {
    .rsc-container {
      padding-top: 90px;
    }
  }

  .rsc-cs {
    box-shadow: none;
    justify-content: flex-end;
  }

  .rsc-ts {
    padding: 0 3% !important;
  }

  .rsc-ts-image-container {
    width: 67px;
    order: 0 !important;
  }

  .rsc-os-options {
    margin: 0 auto;
    width: 100%;
  }

  .rsc-os-option {
    border: solid 5px #dfdfdf;
    background-color: white;
    margin-right: 10px;
    border-radius: 63px;
    vertical-align: middle;
    /* text-align: center; */
    overflow: hidden;
    /* min-width: 209px; */
    height: auto;

    &:hover {
      border: solid 5px #272d67;

      a {
        color: #272d67;
      }
    }

    a {
      background-color: transparent;
      color: #9b9b9b;
      font-family: var(--font-family-base);
      box-shadow: none;
      width: 100%;
      height: 100%;
      font-size: 18px;
      font-weight: 600;
      line-height: normal;
      padding: 1.025em 1.75em;
      display: inline-block;
      &:hover {
        opacity: 1;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .rsc-ts-image-container {
      width: 57px;
    }
  }

  @media screen and (max-width: 813px) {
    .rsc-container {
      height: 100%;
      box-shadow: none;
    }
    .rsc-os-option {
      border-width: 2px;
      padding: 0 0.7em;
      min-width: unset;

      &:hover {
        border-color: #dfdfdf;
        border-width: 2px;

        a {
          color: #9b9b9b;
        }
      }

      a {
        font-size: 12px;
        padding: 0.6em 0.6em;
      }
    }
  }
`;

//For Name, etc.
export const QuestionComponent = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  align-items: center;

  &.right {
    justify-content: flex-end;
  }

  .question-component {
    height: 100%;
    overflow: auto;
    padding: 75px 5% 150px;
    width: 100%;
  }

  .question__responses {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: auto;
    width: 100%;
  }
  .question__responses:not(.textbox) {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }
  .question__responses.textbox {
    margin-left: 0;
    margin-right: 0.5em;
    border-radius: 38px;
    border: solid 4px var(--white-two);
    padding: 0;
    display: flex;
    align-items: center;
  }

  .question__responses.textbox.filled {
    border-color: var(--dark-slate-blue);
  }
  .question__responses.textbox input {
    width: 80%;
    height: auto;
    font-family: var(--font-family-base);
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: left;
    color: black;
    padding: 0;
  }
  .question__responses.textbox input::placeholder {
    color: var(--white-two);
  }

  .question__responses.textbox {
    margin-bottom: 11px;
    height: 37px;
  }

  @media screen and (max-width: 900px) {
    .question-component__inner {
      &.right {
        align-items: flex-start;
        margin: 0;
        flex-direction: column;
        position: absolute;
        left: 70px;
      }
    }
  }

  @media screen and (max-width: 813px) {
    .question__responses.textbox input {
      font-size: 14px;
    }
  }
`;

//Submit Button

export const QuestionComponentButton = styled.button`
  padding: 0;
  height: 30px;
  min-width: 30px;
  color: var(--white);
  display: inline-block;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  text-align: center;
  z-index: 100;
  -webkit-transition: color ease 0.5s;
  transition: color ease 0.5s;
  -webkit-transition: box-shadow ease-in-out 0s;
  transition: box-shadow ease-in-out 0s;
  border: 0;
  background-color: var(--pale-salmon);

  &.disabled {
    background-color: #d8d8d8;
  }
`;

export const MultComponentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  -webkit-transition: border-color 800ms;
  transition: border-color 800ms;
  width: 199px;
  height: 64px;
  vertical-align: middle;
  text-align: center;
  margin-top: 1em;
  font-weight: 600;
  background-color: var(--pale-salmon);
  border-radius: 63px;
  font-size: 22px;

  @media screen and (max-width: 813px) {
    &.multiselect-component__image-wrapper-btn {
      font-size: 14px;
      width: 72px;
      height: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ath/utils/styles.js